import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class HomePageService {

  /**
   * Get data collection count.
   * dataFrequencyType null or 'CY': use period (e.g. 2026-01-01). 'FY': use periodStart and periodEnd.
   */
  static getDataCollectionCount(period, periodStart = null, periodEnd = null) {
    const usePeriod = Boolean(periodStart && periodEnd);
    const url = usePeriod
      ? API_ROUTES.HOME_PAGE_CONFIG.GET_DATA_COL_COUNT_PERIOD
          .replace('<periodStart>', periodStart)
          .replace('<periodEnd>', periodEnd)
      : API_ROUTES.HOME_PAGE_CONFIG.GET_DATA_COL_COUNT.replace('<period>', period);
    return HttpUtil.get(url);
  }

  static getReportDataCount(period, regulationId) {
    return HttpUtil.get(
      API_ROUTES.HOME_PAGE_CONFIG.GET_REPORT_COUNT
        .replace('<period>', period)
        .replace('<regulationId>', regulationId)
    );
  }

  static getESRSReportDataCount(period, periodStart, periodEnd, regulationId, frequencyType) {
    return HttpUtil.getFromReportingService(
      API_ROUTES.HOME_PAGE_CONFIG.GET_ESRS_REPORT_COUNT
        .replace('<period>', period)
        .replace('<periodStart>', periodStart)
        .replace('<periodEnd>', periodEnd)
        .replace('<regulationId>', regulationId)
        .replace('<frequencyType>', frequencyType)
    );
  }

  static getPerfHighlights(period, category, standardId) {
    return HttpUtil.get(
      API_ROUTES.HOME_PAGE_CONFIG.GET_PERF_HIGHLIGHTS
        .replace('<standardId>', standardId)
        .replace('<category>', category)
        .replace('<period>', period)
    );
  }

  /**
   * Unreported / unanswered data points per child branch (metric data view analytics).
   */
  static getBranchUnansweredDataPoints(payload) {
    return HttpUtil.post(API_ROUTES.HOME_PAGE_CONFIG.GET_BRANCH_UNANSWERED_DPS, payload);
  }

}
